import { useAuth } from '../../../../src/auth/useAuth';

const SettingsSubscription = () => {
  const { user } = useAuth();

  if (!user) return <></>;
  return (
    <div className='flex w-full cursor-pointer flex-col items-center justify-start gap-8 rounded-2xl bg-white p-8 shadow-md'>
      <h3 className='mb3 text-blue-primary w-full text-2xl font-bold'>Gestion de l&apos;abonnement / licence</h3>
    </div>
  );
};

export default SettingsSubscription;
